import React from 'react'
import { useNavigate } from "react-router-dom";

import { Header } from '../../../component/Typogaphy/Header';
import { BackgroundAuth } from '../../../component/Auth/BackgroundAuth';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Divider } from '@mui/material';

import { FaUserCircle } from "react-icons/fa";

import { pageRoutes } from '../../../routes/pageRoutes';
import EnterOTP from "../../../assets/images/EnterOTP.gif"

export const OTPEmail = ({ handleStep }) => {

    const navigate = useNavigate();

    return (
        <div className='w-full  bg-white max-w-[800px] rounded-lg p-3 flex flex-col gap-2 drop-shadow-md'>

            <div className='flex flex-row items-center gap-2 w-full justify-between'>
                <div className='max-w-[400px] w-full max-h-[500px] h-full flex flex-col  items-center justify-center'>
                    <img className='h-full w-full' src={EnterOTP} alt='N/A' />
                </div>
                <div>
                    <div className='w-full items-center flex flex-col gap-2 my-3'>
                        {/* 
                <img
                    className='w-[120px] h-[45px] hidden max-md:block'
                    src={require('../../../assets/images/NBPO_LOGO.png')}
                    alt=''
                /> */}

                        <span className='text-3xl text-green-600 block max-md:hidden'><FaUserCircle /></span>
                        <Header text={"Reset password verification code "} style={"text-xl font-lexend text-center"} />
                        <h1 className='text-xs text-[#556fa8] font-semibold self-center'>Please enter the OTP code that was sent to the provided email address</h1>

                    </div>

                    <div className='w-full flex flex-col gap-3 mb-10'>

                        <FormControl>
                            <span className='mb-3 font-medium text-[#556fa8]'>Enter OTP</span>

                            <TextField
                                id="outlined-required"
                                size="small"
                                type='email'
                                placeholder="type here..."
                            />
                        </FormControl>

                        <div onClick={() => handleStep(2)} className='w-full font-lexend bg-[#2e6b1f] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                            <span>Submit</span>
                        </div>

                        <div className='mt-2'><Divider /></div>

                        <div className='w-full justify-center flex flex-row gap-2'>
                            <span className='text-black font-light text-sm font-lexend'>Already have an account?</span>
                            <span onClick={() => navigate(pageRoutes.LOGIN)} className='text-[#2e6b1f] font-medium font-lexend text-sm cursor-pointer hover:text-[#556fa8]'>Sign In Now</span>
                        </div>

                    </div>
                </div>
            </div>




        </div>
    )
}
